export default __webpack_public_path__ + "static/media/luis_beltran.f2421d87.png";